import React from "react";
import { useForm } from "react-hook-form";
import { Outlet, useLocation } from "react-router";

import TeamForm from "./components/TeamForm";
import { TeamProvider } from "./contexts/Team";
import { IClubhouseTeamInfoData } from "./types/team";

import { selectSelectedTeam } from "../../../../features/clubhouse/clubhouseSlice";
import { selectUmpires } from "../../../../features/global/globalSlice";
import { selectUsers } from "../../../../features/user/userSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

const ClubhouseTeam = (): React.JSX.Element => {
    const location = useLocation();
    const isOnTeamPage = /team\/\d+\/?$/.test(location.pathname);
    const team = useAppSelector(selectSelectedTeam);
    const umpires = useAppSelector(selectUmpires);
    const users = useAppSelector(selectUsers);

    const methods = useForm<IClubhouseTeamInfoData>({
        mode: "onChange",
        defaultValues: {
            name: team?.name,
            coach: users.find(u => u.id === team?.coach.id)
                ? {
                      value: team?.coach.id,
                      label: `${team?.coach.firstName} ${team?.coach.lastName} (${team?.coach.email})`,
                  }
                : undefined,
            settings: {
                hideResumeFromCoach:
                    team?.settings?.hideResumeFromCoach || false,
                hideResumeFromPlacement:
                    team?.settings?.hideResumeFromPlacement || false,
                showResumeToCoach: team?.settings?.showResumeToCoach || false,
            },
            bannedUmpire1: team?.bannedUmpires?.length
                ? {
                      value: team.bannedUmpires[0],
                      label:
                          umpires.find(
                              u =>
                                  team.bannedUmpires &&
                                  u.id === team.bannedUmpires[0],
                          )?.name || "Unknown Umpire",
                  }
                : null,
            bannedUmpire2:
                team?.bannedUmpires?.length && team.bannedUmpires[1]
                    ? {
                          value: team.bannedUmpires[1],
                          label:
                              umpires.find(
                                  u =>
                                      team.bannedUmpires &&
                                      u.id === team.bannedUmpires[1],
                              )?.name || "Unknown Umpire",
                      }
                    : null,
        },
    });
    return isOnTeamPage ? (
        <TeamProvider team={team} formMethods={methods}>
            <TeamForm />
        </TeamProvider>
    ) : (
        <Outlet />
    );
};

export default ClubhouseTeam;
